import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import useQueryParams from '../utils/useQueryParams';
import useGlobalPpis from '../features/PpiContainer/hooks/useGlobalPpis';
import usePpsi from '../features/PpsiContainer/hooks/usePpsi';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import usePpis from '../features/PpiContainer/hooks/usePpis';
import { getPpisForPpsiId } from '../features/PpiContainer/selectors';
import { MARKET_GLOBAL_LANG } from '../features/app/constants';
import PpiList from '../components/PpiList/PpiList';
import usePreviewPpi from '../features/PpiContainer/hooks/usePreviewPpi';
import { ppiCreateFromExistingRoute, ppiCreateRoute } from '../routes';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { EnrichmentData, States } from '../features/PpiContainer/constants';
import View from './views';
import { toJS } from 'utils/immutableUtils';
import PpiListSearch from 'components/PpiList/PpiListSeach';
import { getLanguage } from 'features/app/selectors';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(4)
  },
  paper: {
    margin: '0 auto',
    padding: theme.spacing(3),
    width: 700
  },
  actionsContainer: {
    marginTop: theme.spacing(2)
  },
  copyButton: {
    color: '#fff',
    marginRight: theme.spacing(2)
  },
  createButton: {
    padding: '6px 16px'
  },
  goBackButton: {
    padding: '6px 16px',
    marginLeft: '345px'
  }
}));

/**
 * View where user selects which PPI to copy data from when creating a PPI.
 *
 * Note: Only works when providing id of global PPSI (as query param fromPpsiId)
 */
const PpiCreateFromExistingSelectPpiView = () => {
  const classes = useStyles();
  const [itemCode, fromPpsiId, localPpiCopy] = useQueryParams(
    'itemCode',
    'fromPpsiId',
    'localPpiCopy'
  );
  const [fromPpiId, setFromPpiId] = useState(null);
  const [fromPpiDataId, setFromPpiDataId] = useState(null);
  const history = useHistory();
  const [isFetchingGlobalPpis] = useGlobalPpis();
  const [isFetchingFromPpsi] = usePpsi(fromPpsiId);
  const [isFetching, ppis] = usePpis(States.PUBLISHED);
  const ppsis = toJS(ppis, []);
  const isFetchings = isFetchingGlobalPpis || isFetchingFromPpsi || isFetching;
  const globalPpi = useSelector(getPpisForPpsiId(fromPpsiId));
  const globalPpis = toJS(globalPpi, []);
  const [previewNode, openPreview] = usePreviewPpi();
  const [searchInput, setSearchInut] = useState('');
  const [localData, setLocalData] = useState([]);
  const languages = useSelector(getLanguage);

  function filterData() {
    const data = ppsis.filter(i => {
      const name =
        i.publishedPPIEnrichmentData.info[languages].presentationName;
      const finalName = name.trim().toLowerCase();
      return finalName.includes(searchInput);
    });
    setLocalData(data);
  }

  // useEffect(() => {
  //   if (searchInput.length === 0) {
  //     setLocalData(ppsis);
  //   } else {
  //     const delayDebounceFn = setTimeout(() => {
  //       filterData();
  //     }, 500);

  //     return () => clearTimeout(delayDebounceFn);
  //   }
  // }, [isFetchings, searchInput]);

  if (isFetchings) {
    return <ProgressFullscreen />;
  }

  const sentData = localPpiCopy === 'true' ? localData : globalPpis;

  const handlePpiSelected = (event, { id }) => {
    setFromPpiId(id);
    setFromPpiDataId(event.target.value);
  };

  const handleClickCopyPpi = () => {
    if (!fromPpiId) {
      alert('Select instruction to copy');
      return;
    }
    history.replace(
      ppiCreateFromExistingRoute(
        fromPpiId,
        fromPpiDataId,
        itemCode,
        localPpiCopy
      )
    );
  };

  const handleClickCreatePpi = () => {
    history.replace(ppiCreateRoute(itemCode));
  };

  View.PpiCreateFromExistingSelectPpi.visit();

  function navigateBack() {
    history.goBack();
  }

  return (
    <div className={classes.container}>
      {previewNode}
      <Paper className={classes.paper}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h6">
            <FormattedMessage id="ppi.createFromExistingSelectPpiHeader" />
          </Typography>
          {localPpiCopy === 'true' && (
            <div>
              <PpiListSearch
                onChangeInput={setSearchInut}
                filterData={filterData}
              />
            </div>
          )}
        </div>
        <PpiList
          ppis={sentData}
          selectedPpiDataId={fromPpiDataId}
          language={MARKET_GLOBAL_LANG}
          onChangeSelectedPpi={handlePpiSelected}
          openPreview={openPreview}
          localPpiCopy={localPpiCopy}
        />
        <div className={classes.actionsContainer}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClickCopyPpi}
            classes={{ root: classes.copyButton }}
          >
            <FormattedMessage id="ppi.copyInstructionButtonLabel" />
          </Button>
          {/* <Tooltip title="Create instruction from scratch">
            <Button
              variant="text"
              onClick={handleClickCreatePpi}
              classes={{ root: classes.createButton }}
            >
              <FormattedMessage id="ppi.createInstruction" />
            </Button>
          </Tooltip> */}
          <Tooltip title="Go back to previous page">
            <Button
              variant="text"
              startIcon={<ArrowBackIcon />}
              position="left"
              classes={{ root: classes.goBackButton }}
              onClick={navigateBack}
            >
              <FormattedMessage id="ppi.goBack" />
            </Button>
          </Tooltip>
        </div>
      </Paper>
    </div>
  );
};

export default PpiCreateFromExistingSelectPpiView;
